import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';
import { isDev } from '../config.js';

/**
 * InsertedHTMLElement Class.
 */
export default class InsertedHTMLElement extends withBreakpointObserver(Base) {
  /**
   * App config.
   * @returns {object}
   */
  static config = {
    name: 'InsertedHTMLElement',
    options: {
      activeBreakpoints: {
        type: String,
        default: 'xxs xs s',
      },
    },
    log: isDev(),
  };

  /**
   * Move the sticky content element in the article
   * @returns {void}
   */
  mounted() {
    this.parentElement = document.querySelector('.js-single-content-parent');
    this.secondTitle = document.querySelector('.js-single-content-parent h2:nth-of-type(2)');
    this.elementToInsert = this.$el;

    if (this.secondTitle) {
      this.parentElement.insertBefore(this.elementToInsert, this.secondTitle);
    }
  }

  /**
   * Move the sticky content element to the default place
   * @returns {void}
   */
  destroyed() {
    const defaultStickyPlace = document.querySelector('.js-default-sticky-place');

    if (!defaultStickyPlace) {
      return;
    }

    defaultStickyPlace.insertBefore(this.$el, defaultStickyPlace.firstChild);
  }
}
